import { Backdrop, CircularProgress } from "@mui/material";
import { Stack } from "@mui/system";
import React from "react";

const AppBackdop = ({ open, handleClose, message = "Loading" }) => {
  return (
    <Backdrop
      sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
      open={open}
      onClick={handleClose}
    >
      <Stack flexDirection={"row"} gap={2} alignItems={"center"}>
        <CircularProgress color="inherit" />
        {message}...
      </Stack>
    </Backdrop>
  );
};

export default AppBackdop;
